import { useState } from 'react';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ProblemsSolved from './components/ProblemsSolved';
import WhenNeeded from './components/WhenNeeded';
import CommonProblems from './components/CommonProblems';
import WhySpecialistsFail from './components/WhySpecialistsFail';
import LeadershipVsManagement from './components/LeadershipVsManagement';
import ProgramStructure from './components/ProgramStructure';
import TypesOfTrainings from './components/TypesOfTrainings';
import WhatLeadersLearn from './components/WhatLeadersLearn';
import LeaderMistakes from './components/LeaderMistakes';
import CompanyResults from './components/CompanyResults';
import BeforeAfterTable from './components/BeforeAfterTable';
import SuitableCompanies from './components/SuitableCompanies';
import WhoIsTrainingFor from './components/WhoIsTrainingFor';
import TrainingFormats from './components/TrainingFormats';
import WhyCorporateTraining from './components/WhyCorporateTraining';
import WhyForgetTraining from './components/WhyForgetTraining';
import HowTrainingGoes from './components/HowTrainingGoes';
import TrainingEffectiveness from './components/TrainingEffectiveness';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import EmotionalCTA from './components/EmotionalCTA';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import ComplementaryPrograms from './components/ComplementaryPrograms';
import SEOLinks from './components/SEOLinks';
import Footer from '@/components/feature/Footer';

function PageMeta() {
  return (
    <>
      <SeoTitle title="Тренинг для руководителей | Business Training" />
      <meta name="description" content="Тренинг для руководителей: переход от специалиста к управленцу, постановка задач, мотивация и развитие управленческих навыков." />
      <meta name="keywords" content="корпоративные тренинги, обучение сотрудников, тренинги по продажам, тренинг по переговорам, тренинг по лидерству, тимбилдинг Минск, бизнес-игры Беларусь, тренинг для отдела продаж, soft skills, Минск, Беларусь" />
      <link rel="canonical" href="https://business-training.by/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley" />
      <meta property="og:title" content="Тренинг для руководителей | Business Training" />
      <meta property="og:description" content="Тренинг для руководителей: переход от специалиста к управленцу, постановка задач, мотивация и развитие управленческих навыков." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://business-training.by/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley" />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:image" content="https://readdy.ai/api/search-image?query=Professional%20corporate%20leadership%20training%20environment%20with%20executive%20team%20in%20modern%20boardroom%2C%20warm%20natural%20daylight%2C%20collaborative%20atmosphere%2C%20clean%20aesthetic%2C%20soft%20neutral%20tones%2C%20elegant%20corporate%20interior%2C%20no%20text%20no%20logos&width=1200&height=630&seq=leaders-og-2026&orientation=landscape" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Тренинг для руководителей | Business Training" />
      <meta name="twitter:description" content="Тренинг для руководителей: переход от специалиста к управленцу, постановка задач, мотивация и развитие управленческих навыков." />
      <meta name="twitter:image" content="https://readdy.ai/api/search-image?query=Professional%20corporate%20leadership%20training%20environment%20with%20executive%20team%20in%20modern%20boardroom%2C%20warm%20natural%20daylight%2C%20collaborative%20atmosphere%2C%20clean%20aesthetic%2C%20soft%20neutral%20tones%2C%20elegant%20corporate%20interior%2C%20no%20text%20no%20logos&width=1200&height=630&seq=leaders-og-2026&orientation=landscape" />
      <meta name="last-modified" content="2026-07-16" />
      <meta name="geo.region" content="BY" />
      <meta name="geo.placename" content="Минск" />
      <meta name="geo.position" content="53.9006;27.5590" />
    </>
  );
}

const leadersNavLinks = [
  { label: 'Задачи', target: 'problems' },
  { label: 'Программа', target: 'program' },
  { label: 'Навыки', target: 'skills' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function LeadersTrainingPage() {


  return (
    <>
      
      <SeoTitle title="Тренинг для руководителей | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={leadersNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <div id="problems">
          <ProblemsSolved />
        </div>
        <WhenNeeded />
        <CommonProblems />
        <WhySpecialistsFail />
        <LeadershipVsManagement />
        <div id="program">
          <ProgramStructure />
        </div>
        <TypesOfTrainings />
        <div id="skills">
          <WhatLeadersLearn />
        </div>
        <LeaderMistakes />
        <div id="results">
          <CompanyResults />
        </div>
        <BeforeAfterTable />
        <SuitableCompanies />
        <WhoIsTrainingFor />
        <TrainingFormats />
        <WhyCorporateTraining />
        <WhyForgetTraining />
        <HowTrainingGoes />
        <TrainingEffectiveness />
        <WhyWorkWithMe />
        <EmotionalCTA />
        <CTASection />
        <FAQSection />
        <LeadMagnetBlock variant="compact" />
        <ReadNextSection />
        <ComplementaryPrograms />
        <SEOLinks />
        <Footer />
      </div>
    </>
  );
}